import type { SVGProps } from 'react';

interface RegenerateQuotationIconProps extends SVGProps<SVGSVGElement> {
  className?: string;
}

export function RegenerateQuotationIcon({ className, ...props }: RegenerateQuotationIconProps) {
  return (
    <svg
      width="14"
      height="14"
      viewBox="0 0 14.25 13.7535"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
      {...props}
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M2.81731 13.6285H12.1506C12.6743 13.6285 13.1765 13.4205 13.5467 13.0502C13.917 12.68 14.125 12.1778 14.125 11.6542V7.70544C14.125 7.56263 14.0683 7.42567 13.9673 7.32469C13.8663 7.22371 13.7293 7.16698 13.5865 7.16698H11.2532V1.56195C11.2532 0.540311 10.098 -0.0541506 9.26664 0.539593L9.141 0.629337C8.86587 0.824638 8.53671 0.929315 8.19931 0.9288C7.86191 0.928285 7.53307 0.822605 7.25854 0.626465C6.80022 0.300278 6.25165 0.125 5.6891 0.125C5.12656 0.125 4.57799 0.300278 4.11967 0.626465C3.84514 0.822605 3.51629 0.928285 3.17889 0.9288C2.8415 0.929315 2.51233 0.824638 2.23721 0.629337L2.11156 0.539593C1.28018 -0.0541506 0.125 0.539593 0.125 1.56195V10.9362C0.125 11.6503 0.408653 12.3351 0.913559 12.84C1.41846 13.3449 2.10326 13.6285 2.81731 13.6285ZM4.74572 1.50236C5.02137 1.30668 5.35105 1.20156 5.6891 1.20156C6.02715 1.20156 6.35683 1.30668 6.63249 1.50236C7.08961 1.82911 7.6373 2.00508 8.19919 2.00572C8.76109 2.00637 9.30918 1.83166 9.76705 1.50595L9.89269 1.41621C9.91951 1.39712 9.95105 1.38577 9.98388 1.3834C10.0167 1.38103 10.0496 1.38774 10.0788 1.40278C10.1081 1.41783 10.1327 1.44063 10.1499 1.46871C10.1671 1.49678 10.1762 1.52904 10.1763 1.56195V11.6542C10.1763 11.9772 10.2538 12.2824 10.3917 12.5516H2.81731C2.38888 12.5516 1.978 12.3814 1.67506 12.0785C1.37212 11.7755 1.20192 11.3646 1.20192 10.9362V1.56195C1.20201 1.52904 1.21114 1.49678 1.22833 1.46871C1.24552 1.44063 1.27009 1.41783 1.29937 1.40278C1.32864 1.38774 1.36149 1.38103 1.39432 1.3834C1.42715 1.38577 1.4587 1.39712 1.48551 1.41621L1.61115 1.50595C2.06902 1.83166 2.61711 2.00637 3.17901 2.00572C3.74091 2.00508 4.2886 1.82911 4.74572 1.50236ZM11.2532 11.6542V8.2439H13.0481V11.6542C13.0481 11.8922 12.9535 12.1204 12.7852 12.2887C12.6169 12.457 12.3887 12.5516 12.1506 12.5516C11.9126 12.5516 11.6844 12.457 11.5161 12.2887C11.3478 12.1204 11.2532 11.8922 11.2532 11.6542Z"
        fill="currentColor"
        stroke="currentColor"
        strokeWidth="0.25"
      />
      <path
        d="M7.8467 8.99804C7.49784 9.34689 7.06834 9.60432 6.59623 9.74753C6.12412 9.89074 5.62398 9.91531 5.14011 9.81906C4.65624 9.72281 4.20358 9.50872 3.82221 9.19574C3.44084 8.88276 3.14255 8.48056 2.95375 8.02476C2.76496 7.56897 2.69148 7.07364 2.73984 6.58267C2.78819 6.09169 2.95688 5.62022 3.23097 5.21001C3.50506 4.7998 3.87609 4.46352 4.31118 4.23095C4.74628 3.99839 5.23201 3.87671 5.72537 3.87671C7.07803 3.87671 7.89803 4.77838 8.72537 5.71004"
        stroke="currentColor"
        strokeWidth="1.25"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M8.72572 4.37671V5.71004H7.39238"
        stroke="currentColor"
        strokeWidth="1.25"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}
